module.exports = __webpack_public_path__ + "img/12k.77f8cd8e.jpg";